import { LandingPageDTO } from '@tj/tj-dmp-lib-api';

/** Variable du lien personnel dans les emails (params.data.<nom>) : même règle que LandingPage.linkParamName (common-lib). */
export function landingPageLinkParamName(landingPageCode: string): string {
    if (!landingPageCode?.trim()) {
        return '';
    }
    const code = landingPageCode.trim().replace(/^LP_/i, '');
    return 'url_' + code.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

/** Libellés des landing pages : le code est ajouté quand plusieurs landing pages portent le même nom. */
export function landingPageOptions(landingPages: LandingPageDTO[]): { label: string; value: string }[] {
    const sorted = landingPages
        .filter(landingPage => !!landingPage.code)
        .sort((a, b) => (a.name || a.code).localeCompare(b.name || b.code));
    const nameCount = new Map<string, number>();
    sorted.forEach(landingPage => nameCount.set(landingPage.name || landingPage.code, (nameCount.get(landingPage.name || landingPage.code) || 0) + 1));
    return sorted.map(landingPage => {
        const name = landingPage.name || landingPage.code;
        return { label: nameCount.get(name) > 1 ? `${name} (${landingPage.code})` : name, value: landingPage.code };
    });
}
